var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 34.666668,
    viewBox: "0 0 53.333332 34.666668",
    width: 53.333332,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.13333333 0 0 -.13333333 0 34.666667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m400 0h-400v260h400z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 200h-400v60h400z",
    fill: "#265697"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400 0h-400v60h400z",
    fill: "#eb8518"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#265697"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m249.859 163.414c-4.097 1.57-10.519 3.25-18.531 3.25-20.43 0-34.82-10.508-34.937-25.574-.118-11.133 10.269-17.344 18.117-21.055 8.047-3.801 10.746-6.222 10.707-9.613-.043-5.203-6.426-7.57-12.363-7.57-8.282 0-12.676 1.175-19.469 4.066l-2.66 1.234-2.895-17.3512c4.824-2.1641 13.75-4.0391 23.027-4.1367 21.727 0 35.84 10.3906 35.997 26.4839.078 8.817-5.43 15.524-17.36 21.055-7.226 3.586-11.644 5.977-11.601 9.61 0 3.222 3.75 6.667 11.836 6.667 6.761.106 11.656-1.402 15.472-2.968l1.852-.895z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.379 115.293c1.707 4.469 8.23 21.664 8.23 21.664-.121-.203 1.7 4.488 2.75 7.398l1.391-6.683s3.961-18.496 4.785-22.379zm25.492 49.949h-15.973c-4.949 0-8.656-1.375-10.828-6.426l-30.703-71.023h21.703s3.555 9.5508 4.356 11.6445c2.379 0 23.461-.0352 26.48-.0352.61-2.707 2.508-11.6093 2.508-11.6093h19.191z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.203 87.8164 12.93 77.4996h20.68l-12.946-77.4996z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.871 165.266-20.246-52.856-2.148 10.742c-3.774 12.379-15.5082 25.797-28.6372 32.512l18.5122-67.7773 21.875.0235 32.543 77.3558z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m97.8516 165.309h-33.336l-.2617-1.606c25.9375-6.418 43.0941-21.922 50.2231-40.551l-7.25 35.618c-1.25 4.906-4.883 6.371-9.3754 6.539",
    fill: "#d97b16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.a15b58c855f6efbe31a4324558634029.svg";
export { ForwardRef as ReactComponent };